import update from '@scoir/immutability'
import { without } from 'lodash'

import types from './types'

export { default as actions } from './actions'

const INITIAL_STATE = {
  queue: [],
}

export default (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case types.ADD_SNACKBAR_ITEM:
      return update(state, {
        queue: {
          $push: [action.payload],
        },
      })
    case types.DISMISS_SNACKBAR_ITEM:
      return update(state, {
        queue: (queue) => without(queue, action.payload),
      })
    default:
      return state
  }
}
